import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';
import DashboardLineChart from './DashboardLineChart';
import { StoreMetricData } from 'types/storeMetrics';
import { Interval } from 'types/daysAndInterval';

type Props = {
  labelLeft: string;
  labelRight: string;
  dataLeft: StoreMetricData;
  dataRight: StoreMetricData;
  unitLeft: string;
  unitRight: string;
  interval: Interval;
};

export default function DashboardTogglableLineChart({ labelLeft, labelRight, dataLeft, dataRight, unitLeft, unitRight, interval }: Props) {
  const [left, setLeft] = useState<boolean>(true);

  const handleChange = (event: any, newValue: boolean | null) => {
    if (newValue !== null) {
      setLeft(newValue);
    }
  };

  const data = left ? dataLeft : dataRight;
  const unit = left ? unitLeft : unitRight;

  return (
    <Box sx={{ flex: 1, mt: 1.2 }}>
      <ToggleButtonGroup color='primary' value={left} exclusive onChange={handleChange} size='small'>
        <ToggleButton value={true}>{labelLeft}</ToggleButton>
        <ToggleButton value={false}>{labelRight}</ToggleButton>
      </ToggleButtonGroup>
      <DashboardLineChart unit={unit} data={data} interval={interval} />
    </Box>
  );
}
